export const USD_FORMAT_DECIMALS = 2;
export const USD_EXCHANGE_MINIMUM = 0.001;
export const SMALL_VALUE_DECIMALS = 14;
export const LARGE_VALUE_MAX_DIGITS = 10;
